module.exports = __webpack_public_path__ + "static/img/Frame.b206e900.png";